import type { ContractLicense } from 'types/client/contract';

export const CONTRACT_LICENSES: Array<ContractLicense> = [
  {
    type: 'none',
    label: 'None',
    title: 'No License',
    url: 'https://choosealicense.com/no-permission/',
  },
  {
    type: 'unlicense',
    label: 'Unlicense',
    title: 'The Unlicense',
    url: 'https://choosealicense.com/licenses/unlicense/',
  },
  {
    type: 'mit',
    label: 'MIT',
    title: 'MIT License',
    url: 'https://choosealicense.com/licenses/mit/',
  },
  {
    type: 'gnu_gpl_v2',
    label: 'GNU GPLv2',
    title: 'GNU General Public License v2.0',
    url: 'https://choosealicense.com/licenses/gpl-2.0/',
  },
  {
    type: 'gnu_gpl_v3',
    label: 'GNU GPLv3',
    title: 'GNU General Public License v3.0',
    url: 'https://choosealicense.com/licenses/gpl-3.0/',
  },
  {
    type: 'gnu_lgpl_v2_1',
    label: 'GNU LGPLv2.1',
    title: 'GNU Lesser General Public License v2.1',
    url: 'https://choosealicense.com/licenses/lgpl-2.1/',
  },
  {
    type: 'gnu_lgpl_v3',
    label: 'GNU LGPLv3',
    title: 'GNU Lesser General Public License v3.0',
    url: 'https://choosealicense.com/licenses/lgpl-3.0/',
  },
  {
    type: 'bsd_2_clause',
    label: 'BSD-2-Clause',
    title: 'BSD 2-clause "Simplified" license',
    url: 'https://choosealicense.com/licenses/bsd-2-clause/',
  },
  {
    type: 'bsd_3_clause',
    label: 'BSD-3-Clause',
    title: 'BSD 3-clause "New" Or "Revised" license',
    url: 'https://choosealicense.com/licenses/bsd-3-clause/',
  },
  {
    type: 'mpl_2_0',
    label: 'MPL-2.0',
    title: 'Mozilla Public License 2.0',
    url: 'https://choosealicense.com/licenses/mpl-2.0/',
  },
  {
    type: 'osl_3_0',
    label: 'OSL-3.0',
    title: 'Open Software License 3.0',
    url: 'https://choosealicense.com/licenses/osl-3.0/',
  },
  {
    type: 'apache_2_0',
    label: 'Apache',
    title: 'Apache 2.0',
    url: 'https://choosealicense.com/licenses/apache-2.0/',
  },
  {
    type: 'gnu_agpl_v3',
    label: 'GNU AGPLv3',
    title: 'GNU Affero General Public License',
    url: 'https://choosealicense.com/licenses/agpl-3.0/',
  },
  {
    type: 'bsl_1_1',
    label: 'BSL 1.1',
    title: 'Business Source License',
    url: 'https://mariadb.com/bsl11/',
  },
];
